import { Component } from '@grafikr/components';

export default Component((node) => {
  document.addEventListener('cart:fetched', ({ detail: cart }) => {
    node.textContent = `${cart.item_count}`;
  });
});
